<template>
  <div class="tools">
    <!-- Header -->
    <div class="bg-secondary text-neutral-content flex items-center justify-between p-2 px-4 mt-[-5px] rounded-b-lg min-h-[45px]">
      <div class="text-xl">Templates</div>
      <div class="flex items-center gap-2">
        <button class="btn btn-ghost" @click="newTemplate()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
        </button>
      </div>
    </div>

    <!-- update badge -->
     <div class="flex justify-center" v-if="updating.length > 0">
    <div class="badge badge-md bg-green-200 border-0 mt-2 w-200">{{this.updating}}<span class="loading loading-dots loading-sm"></span></div>
    </div>

    <!-- Template Cards -->
    <div class="flex flex-wrap gap-2">
      <div class="card card-border bg-base-100 w-[calc(25%-0.5rem)]" v-for="template in templates" :key="template.id">
        <div class="card-body !p-2">
          <h2 class="card-title">{{template.title}} <div v-if="template.public" class="badge badge-xs bg-green-200 border-0 ml-2">Community</div></h2>
          <!-- template.prompt show only first 100 characters -->
          <p>{{ template.prompt.substring(0, 100) }}...</p>
          <div class="card-actions justify-end">
            <!-- Edit , Delete , Duplicate buttons with icons-->
            <div class="mt-4 flex gap-2 justify-end mr-[-10px]">
              <button class="btn btn-sm hover:scale-105 transition duration-500" @click="newTemplate(template.title, template.prompt)">Duplicate</button>
              <button class="btn btn-sm btn-secondary hover:scale-105 transition duration-500" v-if="!template.public" @click="editModal(template.$id)">Edit</button>
            </div>    
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Template Modal -->
    <TemplateModal 
      ref="editModal" 
      :editId="editId"
      :editTitle="editTitle" 
      :editContent="editContent" 
      @update:editTitle="editTitle = $event"
      @update:editContent="editContent = $event"
      @save="saveTemplate"
      @delete="deleteTemplate"
    />

    
  </div>
</template>

<script>
import axios from 'axios';
import TemplateModal from './templateModal.vue';
export default {
  name: 'AdminTools',
  components: {
    TemplateModal
  },
  data() {
    return {
      customFields: [],
      editId: null,
      editTitle: 'Edit Template Title',
      editContent: 'Template Content hello {{name}}',
      templates: [],
      updating: "",
      wpUser: window.smartpress_wpUserData ? window.smartpress_wpUserData : {}
    }
  },
  created() {
    this.updating = "Fetching Account Info";
    this.fetchCustomFields().then(async () => {
      this.updating = "";
      if(this.customFields.api_key.length > 1){
        this.updating = "Fetching Account Templates";
        this.fetchTemplates();
      }
    });
  },
  methods: {
    async fetchCustomFields() {
      try {
        let baseUrl = this.wpUser.site_url;
        const response = await fetch(baseUrl + '/wp-json/smartpress/v1/custom-fields', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': window.smartpress_wpApiSettings?.nonce || ''
          }
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch custom fields');
        }
        
        const data = await response.json();
        this.customFields = data;
        console.log(data);
      } catch (error) {
        console.error('Error fetching custom fields:', error);
        this.error = 'Failed to load Account Info, Please contact support.';
      } 
    },
    async fetchTemplates(){
      try{
          //Get Templates from server
          await axios.get("https://67d16eab6a70f6dfc533.10g8.cloud/templates", {
          params:{
            session: this.customFields.api_key,
          }
        }).then(response => {
          if(response.data.success){
          this.templates = response.data.templates.documents;
          this.updating = "";
          }
        });
      }catch(error){
        this.updating = "Retrying to fetch templates";
        setTimeout(() => {
          this.fetchTemplates();
        }, 1000);
      }
      },
    editModal(id, copy = false) {
      if(id && copy){
        this.editTitle = this.templates.find(template => template.$id === id).title;
        this.editContent = this.templates.find(template => template.$id === id).prompt;
      }else{
        this.editId = id;
        this.editTitle = this.templates.find(template => template.$id === id).title;
        this.editContent = this.templates.find(template => template.$id === id).prompt;
      }
      this.$refs.editModal.showModal();
    },
    newTemplate(title, prompt) {
      this.editId = null;
      this.editTitle = title ||  'New Template Title';
      this.editContent = prompt || 'Write an article about {{name}}';
      this.$refs.editModal.showModal();
    },
    async saveTemplate() {
      this.updating = "Saving Template";

      // find template with editID and update title and prompt
      if(this.editId){
        this.templates.find(template => template.$id === this.editId).title = this.editTitle;
        this.templates.find(template => template.$id === this.editId).prompt = this.editContent;
      }

      await axios.post('https://67d16eab6a70f6dfc533.10g8.cloud/templates/'+ (this.editId ? this.editId : ''), {
            session: this.customFields.api_key,
            data: {
                title: this.editTitle,
                prompt: this.editContent
            }
        }).then(response =>{
          if(response.data.success && this.editId==null){
            this.templates.push(response.data.template);
          }
        });
      // Implement your save logic here
      this.updating = "";
      
    },
    async deleteTemplate() {
      this.updating = "Deleting Template";
      await axios.post('https://67d16eab6a70f6dfc533.10g8.cloud/templates/'+this.editId+"/delete", {
        session: this.customFields.api_key
      });
      this.templates = this.templates.filter(template => template.$id !== this.editId);
      this.editId = null;
      this.updating = "";
    }
  }
}
</script> 